export default "__VITE_ASSET___8JLWZl3__"